import { useCallback } from "react";
import RegularButton from "segments/desktop/core-components/button/regular-button/regular-button";
import TemplateHeader from "template-store/components/template-header/template-header";
import TemplateBenefits from "template-store/components/template-benefits/template-benefits";
import TemplateLongDescription from "template-store/components/template-long-description/template-long-description";
import { getPlatformAddSolutionLink } from "/constants/links";
import { withGenericConfig } from "/contexts/generic-config-context";
import { getCategoriesData } from "template-store/services/solution-categories-service";
import { SIGN_UP_WITH_TEMPLATE_CLICKED } from "constants/bigbrain-event-types";
import { trackEvent } from "services/bigbrain-service";
import { getSolutionEnglishName } from "template-store/services/solution-data-service";
import { getSolutionsHomeLink } from "template-store/services/solution-links-service";
import ArrowLeft from "static/svg/arrow-left.svg";
import Carousel from "segments/desktop/core-components/carousel/carousel";
import PictureComponent from "/components/core/picture/picture-component";
import { componentStyles } from "./mobile-template-page-content.scss";

const MobileTemplatePageContent = (props) => {
  const { template, templateId, translate, allCategories } = props;
  const templateData = template?.data;

  const onUseTemplateClickAction = useCallback(() => {
    trackEvent(SIGN_UP_WITH_TEMPLATE_CLICKED, { kind: templateId, info1: getSolutionEnglishName(template) });
  }, [template, templateId]);

  const assets = templateData?.images;
  const assetRenderer = (imageData) => (
    <div className="template-image-wrapper">
      <PictureComponent className="template-image" src={imageData?.url} alt={imageData?.title} />
    </div>
  );

  return (
    <div className="mobile-template-page-content-component">
      <div className="template-center-link-wrapper">
        <ArrowLeft className="arrow-left" />
        <a href={getSolutionsHomeLink()} className="template-center-link">
          {translate("templateCenter.template.templateCenterName")}
        </a>
      </div>
      <div className="template-top-section-wrapper">
        <div className="header-wrapper">
          <TemplateHeader
            templateName={templateData?.name}
            templateCategoriesData={getCategoriesData(allCategories, templateData?.categories)}
            categoriesPrefixText={translate("templateCenter.category.idealFor")}
          />
        </div>
      </div>

      <div className="assets-carousel-wrapper">
        <Carousel
          items={assets}
          itemRenderer={assetRenderer}
          slidesToShow={1}
          centerPadding="16px"
          autoplay={false}
          dots={true}
          carouselClassName="template-page-carousel"
          defaultIndex={0} // TODO: barben i think this should be the default prop
        />
      </div>

      <div className="template-description-wrapper">
        <div className="template-description"> {templateData?.description}</div>
      </div>

      <div className="button-wrapper">
        <RegularButton
          buttonText={translate("templateCenter.template.useTemplate")}
          url={getPlatformAddSolutionLink(templateId)}
          isOpenLinkInNewTab={true}
          onClick={onUseTemplateClickAction}
          buttonSize="full"
        />
      </div>

      <div className="benefits-wrapper">
        <TemplateBenefits benefits={templateData?.benefits} />
      </div>

      {templateData?.longDescription && (
        <div className="long-description-wrapper">
          <hr className="template-long-description-divider" />
          <TemplateLongDescription descriptions={templateData.longDescription} />
        </div>
      )}

      <style jsx>{componentStyles}</style>
    </div>
  );
};

MobileTemplatePageContent.defaultProps = {};

export default withGenericConfig(MobileTemplatePageContent);
